export const PRICE_RANGE = "PRICE_RANGE";
export const BY_CATEGORY = "BY_CATEGORY";
export const BY_INTENTION = "BY_INTENTION";
export const BY_USER_RATINGS = "BY_USER_RATINGS";
export const SORT_BY = "SORT_BY";
export const CLEAR = "CLEAR";
